export const PAYMENT_LIST_REQUEST = 'PAYMENT_LIST_REQUEST';
export const PAYMENT_LIST_SUCCESS = 'PAYMENT_LIST_SUCCESS';
export const PAYMENT_LIST_FAIL = 'PAYMENT_LIST_FAIL';

export const PAYMENT_LIST_SAVE_REQUEST = 'PAYMENT_LIST_SAVE_REQUEST';
export const PAYMENT_LIST_SAVE_SUCCESS = 'PAYMENT_LIST_SAVE_SUCCESS';
export const PAYMENT_LIST_SAVE_FAIL = 'PAYMENT_LIST_SAVE_FAIL';
export const PAYMENT_LIST_SAVE_RESET = 'PAYMENT_LIST_SAVE_RESET';
